// The base path a buyer page runs under (plan Task A4): "" on a shop's own host, "/<slug>" on the slug host
// (apparel.shop.bagcarriers.com/<slug>), "/_shop/<slug>" behind a path mount, and "/studio-app" when the portal serves
// Studio on its own origin (its netlify.toml proxies /studio-app/* here). Every API call and in-page link is prefixed
// with it, so the same page works wherever a shop is served.
import { SLUG_HOST } from "../../src/lib/hosts.ts";

const MOUNT = /^\/_shop\/[a-z][a-z0-9-]{1,30}(?=\/|$)/;
const SLUG = /^\/[a-z][a-z0-9-]{1,30}(?=\/|$)/;
export const PORTAL_PREFIX = "/studio-app";
const PORTAL = /^\/studio-app(?=\/|$)/;

export function basePathOf(hostname: string, pathname: string): string {
  const mount = MOUNT.exec(pathname);
  if (mount) return mount[0];
  if (PORTAL.test(pathname)) return PORTAL_PREFIX;
  if (hostname.toLowerCase() === SLUG_HOST) return SLUG.exec(pathname)?.[0] ?? "";
  return "";
}

export function basePath(): string {
  return typeof location === "undefined" ? "" : basePathOf(location.hostname, location.pathname);
}

// "/api/design" -> "/_shop/testpress/api/design" under a mount; unchanged on a shop's own host.
export const withBase = (path: string): string => `${basePath()}${path}`;

// The path after the base: "/m/<token>" whatever the page is mounted under.
export function pathAfterBase(pathname: string = typeof location === "undefined" ? "/" : location.pathname): string {
  const base = typeof location === "undefined" ? "" : basePathOf(location.hostname, pathname);
  return pathname.slice(base.length) || "/";
}
